import { Entity } from 'webpanel-admin';
import { api } from './api';

export const author = new Entity({
  name: 'Author',
  title: 'Autoři',
  icon: 'user',
  dataSource: api,
  searchable: true,
  render: (values: any) => {
    return `${values.lastname} ${values.firstname}`;
  }
})
  .inputField('firstname', {
    visible: ['list', 'edit', 'search'],
    title: 'Jméno',
    sortable: true,
    filter: true,
    rules: [{ required: true }]
  })
  .inputField('lastname', {
    visible: ['list', 'edit', 'search'],
    title: 'Příjmení',
    sortable: true,
    filter: true,
    rules: [{ required: true }]
  });



// WEBPACK FOOTER //
// ./src/model/author.tsx